import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileExchangeService } from 'src/app/services/file-exchange.service';
import { SnackbarCustomService } from 'src/app/services/snackbar-custom.service';
import { SNACK_MESSAGES, SNACK_TYPES } from 'src/app/shared/messages-constants';

@Component({
  selector: 'app-floating-file-uploader',
  templateUrl: './floating-file-uploader.component.html',
  styleUrls: ['./floating-file-uploader.component.scss']
})
export class FloatingFileUploaderComponent {
  @Input() showFloatingButton = true;
  @Input() isCentered = false;
  @Output() uploadSuccess = new EventEmitter<void>();
  isWindowVisible = false;
  isDragging = false;
  isUploading = false;
  isMinimized = false;
  selectedFile: File | null = null;

  constructor(
    private fileExchangeService: FileExchangeService,
    private snackBar: SnackbarCustomService
  ) { }

  toggleWindow() {
    this.isWindowVisible = !this.isWindowVisible;
    if (!this.isWindowVisible) {
      this.clearSelection();
    }
  }

  toggleMinimize(event: Event) {
    event.stopPropagation();
    this.isMinimized = !this.isMinimized;
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.selectedFile = files[0];
    }
  }

  onFileSelected(event: any) {
    const files = event.target.files;
    if (files && files.length > 0) {
      this.selectedFile = files[0];
    }
  }

  clearSelection() {
    this.selectedFile = null;
    this.isUploading = false;
  }

  async uploadFile() {
    if (!this.selectedFile) return;

    this.isUploading = true;
    try {
      await this.fileExchangeService.uploadFile(this.selectedFile);
      this.snackBar.openSnackBar('Arquivo enviado com sucesso!', SNACK_TYPES.SUCCESS);
      this.uploadSuccess.emit();
      this.toggleWindow();
    } catch (error) {
      this.snackBar.openSnackBar(error?.error?.translatedMessage || SNACK_MESSAGES.ERROR.FAIL_TO_UPLOAD_FILE, SNACK_TYPES.ERROR);
    } finally {
      this.isUploading = false;
    }
  }
}
